import { render, staticRenderFns } from "./WhatsAppContact.vue?vue&type=template&id=41fb2c4c&scoped=true"
import script from "./WhatsAppContact.vue?vue&type=script&lang=js"
export * from "./WhatsAppContact.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppContact.vue?vue&type=style&index=0&id=41fb2c4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fb2c4c",
  null
  
)

export default component.exports